import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const LinkButton = styled(Link)`
  position: fixed;
  bottom: 0;
  right: 0;

  @media (max-width: 568px) {
    transform: scale(0.8);
  }
`
